export default __webpack_public_path__ + "static/media/top-up-transactions.ee7a2345.svg";